import React from "react";

export default function IconLogout() {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.75 12.3351L15.75 9.28116M15.75 9.28116L12.75 6.22725M15.75 9.28116L5.25 9.28116M9.75 12.3351V13.0986C9.75 14.3635 8.74264 15.389 7.5 15.389H4.5C3.25736 15.389 2.25 14.3635 2.25 13.0986V5.46377C2.25 4.1988 3.25736 3.17334 4.5 3.17334H7.5C8.74264 3.17334 9.75 4.1988 9.75 5.46377V6.22725"
        stroke="#3F3F46"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
